module.exports = __webpack_public_path__ + "img/Textarea.fd4ab31d.svg";